export default "__VITE_ASSET__CNseVHTO__"